import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import CTAButton from "../CTAButton";

import css from "./Homepage.scss";

/* eslint-disable react/forbid-prop-types */

const HomepageCallToAction = ({
  href,
  title,
  description,
  buttonText,
  manualLink = false,
  className = ""
}) => {
  return (
    <div className={[css.homepageCallToAction, className || ""].join(" ")}>
      <h1 className={[css.ctaTitle, css.heading1].join(" ")}>
        {!manualLink && <Link to={href}>{title}</Link>}
        {manualLink && <a href={href}>{title}</a>}
      </h1>
      <div className={css.ctaDescription}>
        <p>{description}</p>
      </div>
      <div className={css.ctaButton}>
        <CTAButton
          href={href}
          className={css.ctaButtonInner}
          manualLink={manualLink}
        >
          {buttonText}
        </CTAButton>
      </div>
    </div>
  );
};

HomepageCallToAction.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  manualLink: PropTypes.bool,
  className: PropTypes.string
};

HomepageCallToAction.defaultProps = {
  manualLink: false,
  className: ""
};

const Homepage = ({ className = "" }) => {
  return (
    <div className={className || ""}>
      <div className={["row", css.first_section].join(" ")}>
        <div className={["col-lg-6"].join(" ")} />

        <div className={["col-lg-6", css.guideColumn].join(" ")}>
          <div className={["row"].join(" ")}>
            <HomepageCallToAction
              href="/gallery-guides"
              title="Gallery guides"
              description="View our guides with extended captions and images on your own device when visiting the galleries. Some of the items are accompanied by an audio guide."
              buttonText="See all guides"
              className={[
                "col-xs-12",
                "col-sm-6",
                "col-md-6",
                "col-lg-12",
                css.decoration__paintingsGuide
              ].join(" ")}
            />

            <HomepageCallToAction
              href="/podcasts"
              title="Podcasts"
              description="Listen to podcasts produced by the Library."
              buttonText="See all podcasts"
              className={[
                "col-xs-12",
                "col-sm-6",
                "col-md-6",
                "col-lg-12",
                css.decoration__kidsAudioGuide
              ].join(" ")}
              manualLink
            />
          </div>
        </div>
      </div>
    </div>
  );
};

Homepage.propTypes = {
  className: PropTypes.string
};

Homepage.defaultProps = {
  className: ""
};

export default Homepage;
